window.addEventListener('DOMContentLoaded', function () {
  if (typeof DAILY.openNewsDetail === 'function') {
    DAILY.openNewsDetail();
  }
});

window.addEventListener('DOMContentLoaded', function () {
  const title = document.querySelector('.ttl-main');
  if (title) {
    const sponsor = document.createElement('span');
    sponsor.className = 'sponsor';
    sponsor.textContent = 'Sponsored by GDO';
    title.appendChild(sponsor);
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const h1 = document.querySelector('h1.ttl-main');
  if (!h1) return;

  const sponsor = h1.querySelector('.sponsor');
  if (!sponsor) return;

  // テキストノード（本文部分）だけをラップ
  const nodes = Array.from(h1.childNodes);
  nodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
      const span = document.createElement('span');
      span.className = 'main-text';
      span.textContent = node.textContent;
      h1.insertBefore(span, node);
      h1.removeChild(node);
    }
  });
});
